import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import {
  getBankStatement,
  getBankStatementOpeningBalance,
} from "../../stores/services/report.service";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import { getChartOfAccounts } from "../../stores/services/chatofaccounts.service";
import {
  exportToTxt,
  generateExcel,
  getAllLedgers,
  numberWithCommas,
} from "../../utils/customFunction";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { getTrialBalanceReportData } from "../../stores/services/trial-balance-report.service";
import { array } from "prop-types";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { useSelector } from "react-redux";
import Select from "react-select";
import html2pdf from "html2pdf.js";

//for tree
import "./table.css";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";

function HierarchicalRow(props: {
  data: any;
  periodData: any;
  level: number;
  count: number;
  setCount: any;
  expandall: boolean;
  setExpandAll: any;
  setlevelCheck: any;
  levelCheck: any;
  setMainFamilyCode: any;
  mainFamilyCode: any;
  selectedValues: any;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    data,
    periodData,
    level,
    count,
    setCount,
    expandall,
    setExpandAll,
    setlevelCheck,
    levelCheck,
    setMainFamilyCode,
    mainFamilyCode,
    selectedValues,
  } = props;

  // Level configuration
  const levelConfig = {
    2: {
      codeField: "family_code",
      nameField: "family_name",
      nextLevel: "level3",
      nextLevelField: "level3",
      matchField: "family_code",
      backgroundColor: "rgba(96, 130, 182, 0.8)",
      paddingLeft: "1rem",
      levelCheckKey: "sub_rows",
    },
    3: {
      codeField: "sub_family_code",
      nameField: "sub_family_name",
      nextLevel: "level4",
      nextLevelField: "level4",
      matchField: "sub_family_code",
      backgroundColor: "rgba(96, 130, 182, 0.6)",
      paddingLeft: "1.5rem",
      levelCheckKey: "sub_sub_rows",
    },
    4: {
      codeField: "child_family_code",
      nameField: "child_family_name",
      nextLevel: "level5",
      nextLevelField: "level5",
      matchField: "child_family_code",
      backgroundColor: "rgba(96, 130, 182, 0.4)",
      paddingLeft: "2rem",
      levelCheckKey: "sub_sub_sub_rows",
    },
    5: {
      codeField: "gl_code",
      nameField: "gl_name",
      nextLevel: null,
      nextLevelField: null,
      matchField: "gl_code",
      backgroundColor: "white",
      paddingLeft: "3rem",
      levelCheckKey: null,
    },
  };

  const config = levelConfig[level];

  // Calculate balances
  let calculation: any = "";
  // Inside SimpleRows or HierarchicalRow
  const hasValidPeriodData =
    periodData &&
    (periodData.total_debit !== undefined ||
      periodData.total_credit !== undefined);

  const openingDebit = hasValidPeriodData
    ? parseFloat(periodData.total_debit || 0)
    : 0;
  const openingCredit = hasValidPeriodData
    ? parseFloat(periodData.total_credit || 0)
    : 0;

  calculation =
    parseFloat(data.total_debit || 0) +
    openingDebit -
    (parseFloat(data.total_credit || 0) + openingCredit);

  let reportDebit: any = "";
  let reportCredit: any = "";

  if (calculation > 0) {
    reportDebit = calculation.toFixed(4);
    reportCredit = 0;
  } else if (calculation < 0) {
    reportDebit = 0;
    reportCredit = (calculation * -1).toFixed(4);
  }

  useEffect(() => {
    if (count > 0) {
      if (expandall === true) {
        setIsOpen(true);
      } else if (expandall === false) {
        setIsOpen(false);
      }
    }
  }, [expandall, levelCheck]);

  // Check if current item should be rendered
  if (data[config.codeField] !== "0") {
    return (
      <>
        <tr
          className="border-bottom"
          style={{ backgroundColor: config.backgroundColor }}
        >
          {selectedValues?.columns?.includes("Code") && (
            <td className="htmltoPdfStyle _Code" style={{ width: "5%" }}>
              <small>
                {level === 2 ? data[config.codeField] : data[config.codeField]}
              </small>
            </td>
          )}
          {selectedValues?.columns?.includes("Description") && (
            <td
              className="htmltoPdfStyle _Des"
              style={{ paddingLeft: config.paddingLeft, width: "30%" }}
            >
              {data[config.nextLevelField] &&
              data[config.nextLevelField].length > 0 ? (
                isOpen ? (
                  <IoIosArrowDown
                    onClick={() => {
                      setIsOpen(!isOpen);
                      setCount(0);
                      setExpandAll(false);
                      if (config.levelCheckKey) {
                        setlevelCheck((prev) => ({
                          ...prev,
                          [config.levelCheckKey]: false,
                        }));
                      }
                    }}
                  />
                ) : (
                  <IoIosArrowForward
                    onClick={() => {
                      setIsOpen(!isOpen);
                      setCount(0);
                      setExpandAll(false);
                      if (config.levelCheckKey) {
                        setlevelCheck((prev) => ({
                          ...prev,
                          [config.levelCheckKey]: true,
                        }));
                      }
                    }}
                  />
                )
              ) : null}
              &nbsp;
              {data[config.nameField]}
            </td>
          )}

          {/* Opening Balance Debit */}
          {selectedValues?.balance?.includes("Opening Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Opening Balance Credit")
                  ? 2
                  : 1
              }
              className="htmltoPdfStyle _OBD"
              align="right"
            >
              {numberWithCommas(openingDebit.toFixed(4))}
            </td>
          )}

          {/* Opening Balance Credit */}
          {selectedValues?.balance?.includes("Opening Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Opening Balance Debit")
                  ? 2
                  : 1
              }
              className="htmltoPdfStyle _OBC"
              align="right"
            >
              {numberWithCommas(openingCredit.toFixed(4))}
            </td>
          )}

          {/* For The Period Balance Debit */}
          {selectedValues?.balance?.includes("Period Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Period Balance Credit")
                  ? 2
                  : 1
              }
              className={
                level === 5 ? "htmltoPdfStyle _PBD" : "htmltoPdfStyle _PBD"
              }
              align="right"
            >
              {numberWithCommas(parseFloat(data.total_debit || 0).toFixed(4))}
            </td>
          )}

          {/* For The Period Balance Credit */}
          {selectedValues?.balance?.includes("Period Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Period Balance Debit")
                  ? 2
                  : 1
              }
              className={
                level === 5 ? "htmltoPdfStyle _PBC" : "htmltoPdfStyle _PBC"
              }
              align="right"
            >
              {numberWithCommas(parseFloat(data.total_credit || 0).toFixed(4))}
            </td>
          )}

          {/* Closing Balance Debit */}
          {selectedValues?.balance?.includes("Closing Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Closing Balance Credit")
                  ? 2
                  : 1
              }
              className="htmltoPdfStyle _CBD"
              align="right"
            >
              {numberWithCommas(reportDebit)}
            </td>
          )}

          {/* Closing Balance Credit */}
          {selectedValues?.balance?.includes("Closing Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Closing Balance Debit")
                  ? 2
                  : 1
              }
              className="htmltoPdfStyle _CBC"
              align="right"
            >
              {numberWithCommas(reportCredit)}
            </td>
          )}
        </tr>

        {/* Render children */}
        {isOpen &&
          data[config.nextLevelField] &&
          data[config.nextLevelField].map(
            (nextLevelItem: any, index: number) => {
              let periodNextItem: any = {};
              if (periodData && periodData[config.nextLevelField]) {
                periodData[config.nextLevelField].forEach((periodItemSend) => {
                  if (
                    periodItemSend[levelConfig[level + 1]?.matchField] ===
                    nextLevelItem[levelConfig[level + 1]?.matchField]
                  ) {
                    periodNextItem = periodItemSend;
                  }
                });
              }

              return (
                <HierarchicalRow
                  key={index}
                  data={nextLevelItem}
                  periodData={periodNextItem}
                  level={level + 1}
                  count={count}
                  setCount={setCount}
                  expandall={expandall}
                  setExpandAll={setExpandAll}
                  setlevelCheck={setlevelCheck}
                  levelCheck={levelCheck}
                  setMainFamilyCode={setMainFamilyCode}
                  mainFamilyCode={mainFamilyCode}
                  selectedValues={selectedValues}
                />
              );
            },
          )}
      </>
    );
  } else if (data[config.nextLevelField]) {
    return (
      <>
        {data[config.nextLevelField].map(
          (nextLevelItem: any, index: number) => {
            let periodNextItem: any = {};
            if (periodData && periodData[config.nextLevelField]) {
              periodData[config.nextLevelField].forEach((periodItemSend) => {
                if (
                  periodItemSend[levelConfig[level + 1]?.matchField] ===
                  nextLevelItem[levelConfig[level + 1]?.matchField]
                ) {
                  periodNextItem = periodItemSend;
                }
              });
            }

            return (
              <HierarchicalRow
                key={index}
                data={nextLevelItem}
                periodData={periodNextItem}
                level={level + 1}
                count={count}
                setCount={setCount}
                expandall={expandall}
                setExpandAll={setExpandAll}
                setlevelCheck={setlevelCheck}
                levelCheck={levelCheck}
                setMainFamilyCode={setMainFamilyCode}
                mainFamilyCode={mainFamilyCode}
                selectedValues={selectedValues}
              />
            );
          },
        )}
      </>
    );
  } else {
    return null;
  }
}

// Updated SimpleRows component (top level)
function SimpleRows(props: {
  simplerows: any;
  period: any;
  count: number;
  setCount: any;
  expandall: boolean;
  setExpandAll: any;
  setlevelCheck: any;
  levelCheck: any;
  setMainFamilyCode: any;
  mainFamilyCode: any;
  selectedValues: any;
}) {
  const [simpleOpen, setSimpleOpen] = useState(false);
  const {
    simplerows,
    period,
    count,
    setCount,
    expandall,
    setExpandAll,
    setlevelCheck,
    levelCheck,
    setMainFamilyCode,
    mainFamilyCode,
    selectedValues,
  } = props;

  // Determine if period has valid opening balance data
  const hasValidPeriodData =
    period &&
    typeof period === "object" &&
    (period.total_debit !== undefined || period.total_credit !== undefined);

  const openingDebit = hasValidPeriodData
    ? parseFloat(period.total_debit || 0)
    : 0;

  const openingCredit = hasValidPeriodData
    ? parseFloat(period.total_credit || 0)
    : 0;

  // Calculate closing balance
  const calculation =
    parseFloat(simplerows.total_debit || 0) +
    openingDebit -
    (parseFloat(simplerows.total_credit || 0) + openingCredit);

  const reportDebit = calculation > 0 ? calculation.toFixed(4) : "0";
  const reportCredit = calculation < 0 ? (calculation * -1).toFixed(4) : "0";

  useEffect(() => {
    if (count > 0) {
      if (expandall === true) {
        setSimpleOpen(true);
      } else if (expandall === false) {
        setSimpleOpen(false);
      }
    }
  }, [expandall, levelCheck]);

  if (simplerows.main_family_code !== "0") {
    return (
      <>
        <tr
          className="border-bottom"
          style={{ backgroundColor: "rgba(96, 130, 182, 1.0)" }}
        >
          {selectedValues?.columns?.includes("Code") && (
            <td className="ReportTopStyling _Code" style={{ width: "5%" }}>
              <small>
                <b>{simplerows.main_family_code}</b>
              </small>
            </td>
          )}
          {selectedValues?.columns?.includes("Description") && (
            <td className="ReportTopStyling _Des" style={{ width: "30%" }}>
              <b>
                {simplerows.level2.length > 0 ? (
                  simpleOpen ? (
                    <IoIosArrowDown
                      onClick={() => {
                        setSimpleOpen(!simpleOpen);
                        setCount(0);
                        setExpandAll(false);
                        if (mainFamilyCode?.length <= 1) {
                          setlevelCheck({
                            simple_rows: false,
                            sub_rows: false,
                            sub_sub_rows: false,
                            sub_sub_sub_rows: false,
                          });
                          setMainFamilyCode([]);
                        } else {
                          setMainFamilyCode((prev) =>
                            prev.filter(
                              (code) => code !== simplerows.main_family_code,
                            ),
                          );
                        }
                      }}
                    />
                  ) : (
                    <IoIosArrowForward
                      onClick={() => {
                        setSimpleOpen(!simpleOpen);
                        setCount(0);
                        setExpandAll(false);
                        setlevelCheck((prev) => ({
                          ...prev,
                          simple_rows: true,
                        }));
                        setMainFamilyCode((prev) => {
                          if (!prev.includes(simplerows.main_family_code)) {
                            return [...prev, simplerows.main_family_code];
                          }
                          return prev;
                        });
                      }}
                    />
                  )
                ) : null}
                &nbsp;
                {simplerows.main_family_name}
              </b>
            </td>
          )}

          {/* Opening Balance Debit */}
          {selectedValues?.balance?.includes("Opening Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Opening Balance Credit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _OBD"
              align="right"
            >
              <b>{numberWithCommas(openingDebit.toFixed(4))}</b>
            </td>
          )}

          {/* Opening Balance Credit */}
          {selectedValues?.balance?.includes("Opening Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Opening Balance Debit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _OBC"
              align="right"
            >
              <b>{numberWithCommas(openingCredit.toFixed(4))}</b>
            </td>
          )}

          {/* For The Period Balance Debit */}
          {selectedValues?.balance?.includes("Period Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Period Balance Credit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _PBD"
              align="right"
            >
              <b>
                {numberWithCommas(
                  parseFloat(simplerows.total_debit || 0).toFixed(4),
                )}
              </b>
            </td>
          )}

          {/* For The Period Balance Credit */}
          {selectedValues?.balance?.includes("Period Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Period Balance Debit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _PBC"
              align="right"
            >
              <b>
                {numberWithCommas(
                  parseFloat(simplerows.total_credit || 0).toFixed(4),
                )}
              </b>
            </td>
          )}

          {/* Closing Balance Debit */}
          {selectedValues?.balance?.includes("Closing Balance Debit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Closing Balance Credit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _CBD"
              align="right"
            >
              <b>{numberWithCommas(reportDebit)}</b>
            </td>
          )}

          {/* Closing Balance Credit */}
          {selectedValues?.balance?.includes("Closing Balance Credit") && (
            <td
              colSpan={
                !selectedValues?.balance?.includes("Closing Balance Debit")
                  ? 2
                  : 1
              }
              className="ReportTopStyling _CBC"
              align="right"
            >
              <b>{numberWithCommas(reportCredit)}</b>
            </td>
          )}
        </tr>

        {simpleOpen &&
          simplerows?.level2.map((subItem: any, subIndex: number) => {
            let periodItem: any = {};
            if (period?.level2) {
              period.level2.forEach((periodItemSend) => {
                if (periodItemSend.family_code === subItem.family_code) {
                  periodItem = periodItemSend;
                }
              });
            }
            return (
              <HierarchicalRow
                key={subIndex}
                data={subItem}
                periodData={periodItem}
                level={2}
                count={count}
                setCount={setCount}
                expandall={expandall}
                setExpandAll={setExpandAll}
                setlevelCheck={setlevelCheck}
                levelCheck={levelCheck}
                setMainFamilyCode={setMainFamilyCode}
                mainFamilyCode={mainFamilyCode}
                selectedValues={selectedValues}
              />
            );
          })}
      </>
    );
  } else if (simplerows?.level2) {
    return (
      <>
        {simplerows?.level2.map((subItem: any, subIndex: number) => {
          let periodItem: any = {};
          if (period?.level2) {
            period.level2.forEach((periodItemSend) => {
              if (periodItemSend.family_code === subItem.family_code) {
                periodItem = periodItemSend;
              }
            });
          }

          return (
            <HierarchicalRow
              key={subIndex}
              data={subItem}
              periodData={periodItem}
              level={2}
              count={count}
              setCount={setCount}
              expandall={expandall}
              setExpandAll={setExpandAll}
              setlevelCheck={setlevelCheck}
              levelCheck={levelCheck}
              setMainFamilyCode={setMainFamilyCode}
              mainFamilyCode={mainFamilyCode}
              selectedValues={selectedValues}
            />
          );
        })}
      </>
    );
  } else {
    return null;
  }
}

const TrialBalanceStatement = () => {
  // Refs
  const contentRef = React.useRef(null);
  const pdfExportComponent = React.useRef<PDFExport>(null);

  // Redux state
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const txnTypes = useSelector((state: any) => state.txnTypes);

  // Session storage values
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";

  // Constants
  const date = new Date();
  const ColumnHeading = [
    { label: "Code", value: "Code" },
    { label: "Description", value: "Description" },
    { label: "Opening Balance", value: "Opening Balance" },
    { label: "For The Period Balance", value: "For The Period Balance" },
    { label: "Closing Balance", value: "Closing Balance" },
  ];

  const fixedOrder = [
    "Code",
    "Description",
    "Opening Balance_Debit",
    "Opening Balance_Credit",
    "For The Period Balance_Debit",
    "For The Period Balance_Credit",
    "Closing Balance_Debit",
    "Closing Balance_Credit",
  ];

  const trialBalanceOptions = [
    { label: "Opening Balance Debit", value: "Opening Balance Debit" },
    { label: "Opening Balance Credit", value: "Opening Balance Credit" },
    { label: "Period Balance Debit", value: "Period Balance Debit" },
    { label: "Period Balance Credit", value: "Period Balance Credit" },
    { label: "Closing Balance Debit", value: "Closing Balance Debit" },
    { label: "Closing Balance Credit", value: "Closing Balance Credit" },
  ];

  // State management
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]"),
  );

  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: [
      "Opening Balance Debit",
      "Opening Balance Credit",
      "Period Balance Debit",
      "Period Balance Credit",
      "Closing Balance Debit",
      "Closing Balance Credit",
    ],
  });

  // Loading states
  const [loading, setLoading] = useState(false);
  const [loadingDownloadFile, setLoadingDownloadFile] = useState(false);
  const [loadingDownloadFileTxt, setLoadingDownloadFileTxt] = useState(false);
  const [loadingDownloadFileExcel, setLoadingDownloadFileExcel] =
    useState(false);

  // Data states
  const [allTableData, setAllTableData] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [allFundAccounts, setAllFundsAccounts] = useState<any>([]);
  const [trialBalanceResponse, setTrialBalanceResponse] = useState<any>([]);
  const [periodResponse, setPeriodResponse] = useState<any>([]);
  const [legders, setLegders] = useState<any>([]);
  const [ledgerOption, setLedgerOption] = useState<any>([]);

  // Form states
  const [fund, setFund] = useState("");
  const [type, setType] = useState("");
  const [fundAccount, setFundAccount] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [openingBalance, setOpeningBalance] = useState("");
  const [closingBalance, setClosingBalance] = useState("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));

  // Response states (keeping for backward compatibility)
  const [resAmc, setResAmc] = useState("");
  const [resFund, setResFund] = useState("");
  const [resType, setResType] = useState("");
  const [resFundAccount, setResFundAccount] = useState("");
  const [resAccountTitle, setResAccountTitle] = useState("");
  const [resFromDate, setResFromDate] = useState(
    moment(date).format("YYYY-MM-DD"),
  );
  const [resToDate, setResToDate] = useState(moment(date).format("YYYY-MM-DD"));

  // Ledger autocomplete states
  const [valueSelectedLedger, setValueSelectedLedger] = React.useState<
    string | null
  >("");
  const [inputValueSelectedLedger, setInputValueSelectedLedger] =
    React.useState("");

  // UI states
  const [totalRecords, setTotalRecords] = useState<any>();
  const [loadingtotalRecords, setLoadingtotalRecords] =
    useState<boolean>(false);
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const [itemsPerPage, setItemsPerPage] = useState<any>(10);
  const [itemsToShow, setItemsToShow] = useState(10);
  const [isSearchTrue, setIsSearchTrue] = useState(false);
  const [screen, setScreen] = useState<any>();
  const [totalRecordPage, setTotalRecordPage] = useState<number>(0);
  const { customStyles } = useCustomStylesDropDown();

  // Expand/Collapse states
  const [expandAll, setExpandAll] = useState<any>(false);
  const [count, setCount] = useState<any>(0);
  const [levelCheck, setlevelCheck] = useState({
    simple_rows: false,
    sub_rows: false,
    sub_sub_rows: false,
    sub_sub_sub_rows: false,
  });
  const [mainFamilyCode, setMainFamilyCode] = useState<any>([]);

  // Bank statement states (keeping for compatibility)
  const [bankStatement, setBankStatement] = useState<any>([]);
  const [bankStatementDataCount, SetBankStatementDataCount] = useState(0);

  // Utility functions
  const CapTxnType = (type: any) => {
    const txType = txnTypes.find((tx) => tx.api_name === type);
    return txType ? txType.dis_name : type;
  };

  const numberWithCommas = (amount: any) => {
    return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  };

  const reorderColumns = (columns, order) => {
    return order
      .map((column) =>
        columns.includes(column?.split("_")[0]) ? column : null,
      )
      .filter(Boolean);
  };

  // API functions
  const getAllAmcFunds = async () => {
    try {
      setAllFundsAccounts([]);
      setAllFunds([]);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : "",
      );
      setAllFunds(response.data.data);
    } catch (error) {
      console.error("Error fetching funds:", error);
    }
  };

  const getFundAccounts = async (fund_code) => {
    try {
      setAllFundsAccounts([]);
      const accResponse = await getAccountByFund(email, fund_code, amc_code);
      setAllFundsAccounts(accResponse.data.data);
    } catch (error) {
      console.error("Error fetching fund accounts:", error);
    }
  };
  const generateEmptyPeriodStructure = (
    data: any[],
    levelKeyMap: Record<string, string> = {
      level2: "family_code",
      level3: "sub_family_code",
      level4: "child_family_code",
      // level5 has gl_code
    },
  ) => {
    return data.map((item) => {
      const clonedItem: any = {
        main_family_code: item.main_family_code,
        main_family_name: item.main_family_name,
        total_debit: 0,
        total_credit: 0,
      };

      // Recursively build lower levels if exist
      const levels = ["level2", "level3", "level4", "level5"] as const;
      levels.forEach((level, idx) => {
        const nextLevel = levels[idx + 1];
        const field =
          levelKeyMap[level] || `${level.split("level")[1].toLowerCase()}_code`;

        if (item[level]) {
          clonedItem[level] = item[level].map((subItem) => {
            const subClone = {
              ...(field ? { [field]: subItem[field] } : {}),
              ...(subItem[`${field}`.replace("_code", "_name")]
                ? {
                    [subItem[`${field}`.replace("_code", "_name")]]:
                      subItem[`${field}`.replace("_code", "_name")],
                  }
                : {}),
              total_debit: 0,
              total_credit: 0,
            };

            if (nextLevel && subItem[nextLevel]) {
              subClone[nextLevel] = generateEmptyPeriodStructure(
                subItem[nextLevel],
                levelKeyMap,
              );
            }

            return subClone;
          });
        }
      });

      return clonedItem;
    });
  };

  const countChildren = (node: any, isLevel1 = false): number => {
    let count = 0;

    if (isLevel1) {
      count += 1;
    }

    if (node.level2) {
      count += node.level2.length;
      node.level2.forEach((child: any) => {
        count += countChildren(child);
      });
    }

    if (node.level3) {
      count += node.level3.length;
      node.level3.forEach((child: any) => {
        count += countChildren(child);
      });
    }

    if (node.level4) {
      count += node.level4.length;
      node.level4.forEach((child: any) => {
        count += countChildren(child);
      });
    }

    if (node.level5) {
      count += node.level5.length;
    }

    return count;
  };

  const searchData = async () => {
    setLoading(true);
    try {
      const result = await getTrialBalanceReportData(fund, fromDate, toDate);

      if (result.data.status === 404 || !result.data.data) {
        toast.error("No Record Found");
        setTrialBalanceResponse([]);
        setPeriodResponse([]);
        setIsSearchTrue(false);
        return;
      }

      const mainData = result.data.data; // This is "For The Period" data
      let periodData = result.data.period?.data;

      // If period data is missing or empty, generate empty structure
      if (!periodData || periodData.length === 0) {
        console.warn("No opening balance data found. Initializing with zeros.");
        periodData = generateEmptyPeriodStructure(mainData);
      }

      // for total record calculation start
      let trialBalanceUnsorted = result.data.data;
      let trialBalanceSorted = trialBalanceUnsorted.sort((a, b) =>
        parseInt(a.main_family_code) > parseInt(b.main_family_code) ? 1 : -1,
      );

      let totalLength = 0;

      trialBalanceSorted.forEach((item) => {
        totalLength += countChildren(item, true); // pass true to count level1
      });

      setTotalRecordPage(totalLength);

      // for total record calculation end

      setTrialBalanceResponse(mainData);
      setPeriodResponse(periodData); // Now guaranteed to have full structure
      setIsSearchTrue(true);
    } catch (error) {
      toast.error("Failed to load report data.");
      setTrialBalanceResponse([]);
      setPeriodResponse([]);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalNestedRows = (data) => {
    let totalLength = 0;
    data.forEach((item) => {
      if (item.level2) {
        item.level2.forEach((level2Item) => {
          if (level2Item.level3) {
            totalLength += level2Item.level3.length;
            level2Item.level3.forEach((level3Item) => {
              if (level3Item.level4) {
                totalLength += level3Item.level4.length;
                level3Item.level4.forEach((level4Item) => {
                  if (level4Item.level5) {
                    totalLength += level4Item.level5.length;
                  }
                });
              }
            });
          }
        });
      }
    });
    return totalLength;
  };

  // Render functions
  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => ({
      value: item.symbol_code,
      label: `${item.fund_name} - ${item.symbol_code}`,
    }));
  };

  const renderFundAccountsDropDown = () => {
    return allFundAccounts.map((item: any, index: number) => (
      <option key={index} value={item.account_no}>
        {item.bank_name} ({item.account_title})
      </option>
    ));
  };

  const renderLegdersDropDown = () => {
    return legders.map((item: any, index: number) => (
      <option key={index} value={item.code}>
        {item.code} - {item.name != undefined ? item.name : item.bank}
      </option>
    ));
  };

  // Export functions
  const prepareTableData = () => {
    const tableRows = document.querySelectorAll(".getData tr");
    return Array.from(tableRows).map((row) => {
      const cells = row.querySelectorAll("td");
      return Array.from(cells).reduce((obj, cell, index) => {
        let vauee = cell.className?.split("_");
        obj[`${vauee[vauee?.length - 1]}`] = cell.innerText;
        return obj;
      }, {});
    });
  };

  const prepareDataSequence = (TableData) => {
    return TableData?.map((item: any) => ({
      code: item?.Code || "",
      description: item?.Des || "",
      opening_balance_debit: item?.OBD || "",
      opening_balance_credit: item?.OBC || "",
      period_balance_debit: item?.PBD || "",
      period_balance_credit: item?.PBC || "",
      closing_balance_debit: item?.CBD || "",
      closing_balance_credit: item?.CBC || "",
    }));
  };

  const prepareArrayData = (dataSequence) => {
    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder,
    );
    const reorderedColumn = reorderedColumns?.filter(
      (ele) =>
        selectedValues?.columns?.includes(ele) ||
        selectedValues?.balance?.includes(
          ele?.replace("_", " ")?.replace("For The ", ""),
        ),
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumn.forEach((column) => {
          const columnMap = {
            Code: entry?.code,
            Description: entry?.description,
            "Opening Balance_Debit": entry?.opening_balance_debit,
            "Opening Balance_Credit": entry?.opening_balance_credit,
            "For The Period Balance_Debit": entry?.period_balance_debit,
            "For The Period Balance_Credit": entry?.period_balance_credit,
            "Closing Balance_Debit": entry?.closing_balance_debit,
            "Closing Balance_Credit": entry?.closing_balance_credit,
          };
          result[column] = columnMap[column];
        });
        return result;
      });

    // Add summary row
    if (ArrayData && ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]);
      const summaryRow = keys.reduce((acc, key) => {
        const summaryMap = {
          "Opening Balance_Debit": "Debit",
          "Opening Balance_Credit": "Credit",
          "For The Period Balance_Debit": "Debit",
          "For The Period Balance_Credit": "Credit",
          "Closing Balance_Debit": "Debit",
          "Closing Balance_Credit": "Credit",
        };
        acc[key] = summaryMap[key] || "";
        return acc;
      }, {});
      ArrayData.unshift(summaryRow);
    }

    return ArrayData;
  };

  const handleDownloadSampleFile = () => {
    const headings = [
      [selectedValues?.heading || "", "", "", ""],
      [selectedValues?.sub_heading || "", "", "", ""],
      [
        "From Date",
        moment(fromDate).format("DD-MM-YYYY"),
        "To Date",
        moment(toDate).format("DD-MM-YYYY"),
      ],
      ["Accounts", "ALL", "Fund Name", fund],
    ];

    const TableData = prepareTableData();
    const dataSequence = prepareDataSequence(TableData);
    const ArrayData = prepareArrayData(dataSequence);

    const columnHeaders = [
      selectedValues?.columns?.includes("Code") ? "Code" : null,
      selectedValues?.columns?.includes("Description") ? "Description" : null,
      selectedValues?.balance?.includes("Opening Balance Debit") ||
      selectedValues?.balance?.includes("Opening Balance Credit")
        ? "Opening Balance"
        : null,
      selectedValues?.balance?.includes("Opening Balance Credit") &&
      selectedValues?.balance?.includes("Opening Balance Debit")
        ? ""
        : null,
      selectedValues?.balance?.includes("Period Balance Debit") ||
      selectedValues?.balance?.includes("Period Balance Credit")
        ? "For The Period Balance"
        : null,
      selectedValues?.balance?.includes("Period Balance Credit") &&
      selectedValues?.balance?.includes("Period Balance Debit")
        ? ""
        : null,
      selectedValues?.balance?.includes("Closing Balance Debit") ||
      selectedValues?.balance?.includes("Closing Balance Credit")
        ? "Closing Balance"
        : null,
      selectedValues?.balance?.includes("Closing Balance Credit") &&
      selectedValues?.balance?.includes("Closing Balance Debit")
        ? ""
        : null,
    ].filter((item) => item !== null);

    generateExcel(
      "Trial Balance Report",
      "Trial Balance Report",
      "File",
      "File",
      "DCCL",
      headings,
      columnHeaders,
      ArrayData,
      [],
      [],
    );
    setLoadingDownloadFileExcel(false);
  };

  const handleTXT = () => {
    const TableData = prepareTableData();
    const dataSequence = prepareDataSequence(TableData);
    const ArrayData = prepareArrayData(dataSequence);

    let formattedContent = `${selectedValues?.heading || ""},,,\n`;
    formattedContent += `${selectedValues?.sub_heading || ""},,,\n`;
    formattedContent += `"From Date:","${moment(fromDate).format(
      "DD-MM-YYYY",
    )}",`;
    formattedContent += `"To Date:","${moment(toDate).format(
      "DD-MM-YYYY",
    )}",,\n`;
    formattedContent += `"Accounts:","ALL",`;
    formattedContent += `"Fund Name:","${fund}",,\n`;

    exportToTxt(
      formattedContent,
      selectedValues,
      ArrayData,
      "Trial Balance Report",
    );
    setLoadingDownloadFileTxt(false);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    const fileName = "Trial-Balance.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().from(element).set(options).save();
    setLoadingDownloadFile(false);
  };

  // Event handlers
  const handlePrint = () => {
    setlevelCheck({
      simple_rows: true,
      sub_rows: true,
      sub_sub_rows: true,
      sub_sub_sub_rows: true,
    });
    setExpandAll(true);
    setCount(count + 1);
    setTimeout(() => {
      if (pdfExportComponent.current) {
        pdfExportComponent.current.save();
      }
    }, 3000);
  };

  const handleShowMore = () => {
    setItemsToShow((prev) => prev + itemsPerPage);
  };

  const handleExpandAll = () => {
    setExpandAll(true);
    setCount(count + 1);
    setlevelCheck({
      simple_rows: true,
      sub_rows: true,
      sub_sub_rows: true,
      sub_sub_sub_rows: true,
    });
    setMainFamilyCode(
      Array.from({ length: trialBalanceResponse?.length }).map(
        (_, index) => index + 1,
      ),
    );
  };

  const handleCollapseAll = () => {
    setExpandAll(false);
    setCount(count + 1);
    setlevelCheck({
      simple_rows: false,
      sub_rows: false,
      sub_sub_rows: false,
      sub_sub_sub_rows: false,
    });
    setMainFamilyCode([]);
  };

  const handleFundChange = (selectedOption) => {
    setLoading(true);
    setTrialBalanceResponse([]);
    setPeriodResponse([]);
    setFund(selectedOption?.value);
    getFundAccounts(selectedOption?.value);
    setLoading(false);
    setItemsPerPage(10);
    setItemsToShow(10);
  };

  const handleDateChange = (date, setter) => {
    setLoading(true);
    setTrialBalanceResponse([]);
    setPeriodResponse([]);
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setter(formattedDate);
    setLoading(false);
    setItemsPerPage(10);
    setItemsToShow(10);
  };

  // Computed values
  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds?.find((item) => item?.symbol_code === fund);
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
        }
      : null;
  }, [allFunds, fund]);

  // Effects
  React.useEffect(() => {
    const fundCode = sessionStorage.getItem("fund_code");
    setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test",
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  useEffect(() => {
    const handleScreenResize = () => setScreen(window?.outerWidth);
    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();
    return () => window.removeEventListener("resize", handleScreenResize);
  }, []);

  const shouldShowExpandButton =
    trialBalanceResponse.length > 0 &&
    periodResponse.length > 0 &&
    (!expandAll || Object.values(levelCheck).some((val) => !val));

  const shouldShowCollapseButton =
    trialBalanceResponse.length > 0 &&
    periodResponse.length > 0 &&
    (expandAll || Object.values(levelCheck).some((val) => val));

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Trial Balance</h4>
              </div>
              <div className="card-body">
                <Row>
                  <Col md="3">
                    <div className="form-group">
                      <label>Select Fund</label>
                      <Select
                        value={selectedFundName}
                        label="Select Fund"
                        onChange={handleFundChange}
                        menuPortalTarget={document.body}
                        menuShouldBlockScroll={true}
                        isClearable={true}
                        isSearchable={true}
                        name="color"
                        options={renderFundsDropDown()}
                        styles={customStyles}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="form-group">
                      <label>Date From</label>
                      <input
                        style={{
                          colorScheme: theme === "light" ? "light" : "dark",
                        }}
                        type="date"
                        defaultValue={fromDate}
                        className="form-control py-1"
                        onChange={(e) =>
                          handleDateChange(e.target.value, setFromDate)
                        }
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="form-group">
                      <label>Date To</label>
                      <input
                        style={{
                          colorScheme: theme === "light" ? "light" : "dark",
                        }}
                        type="date"
                        defaultValue={toDate}
                        className="form-control py-1"
                        onChange={(e) =>
                          handleDateChange(e.target.value, setToDate)
                        }
                      />
                    </div>
                  </Col>

                  <Col md="2">
                    <div style={{ marginTop: "5px" }}>
                      <button
                        style={{ paddingTop: "8px", paddingBottom: "8px" }}
                        className="btn btn-primary mt-4"
                        onClick={searchData}
                        disabled={loading || !fund}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Search</span>
                        )}
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            {/* Search results for report Data */}
            <div className="card mt-3">
              <div className="card-header">
                <Row>
                  <Col md="6">
                    <Row>
                      {shouldShowExpandButton && (
                        <Col md="3" sm="12">
                          <button
                            className="btn btn-primary mt-4"
                            onClick={handleExpandAll}
                          >
                            <span>Expand All</span>
                          </button>
                        </Col>
                      )}
                      {shouldShowCollapseButton && (
                        <Col md="3" sm="12">
                          <button
                            className="btn btn-primary mt-4"
                            onClick={handleCollapseAll}
                          >
                            <span>Collapse All</span>
                          </button>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="card-body">
                {/* Report template */}
                {trialBalanceResponse.length > 0 &&
                  periodResponse.length > 0 && (
                    <Row>
                      <ReportTemplates
                        ColumnArr={ColumnArr}
                        selectedValues={selectedValues}
                        setSelectedValues={setSelectedValues}
                        pdfExportComponent={pdfExportComponent}
                        setFontSizeVal={setFontSizeVal}
                        fontSizeVal={fontSizeVal}
                        setPaperSizeVal={setPaperSizeVal}
                        paperSizeVal={paperSizeVal}
                        setLayoutVal={setLayoutVal}
                        layoutVal={layoutVal}
                        setScalePDF={setScalePDF}
                        scalePDF={scalePDF}
                        setMarginPDF={setMarginPDF}
                        marginPDF={marginPDF}
                        setScreenSizePerPdf={setScreenSizePerPdf}
                        screenSizePerPdf={screenSizePerPdf}
                        setDimensionOfPages={setDimensionOfPages}
                        trialBalance={trialBalanceOptions}
                        contentRef={contentRef}
                        fileName={`Trial-Balance-${date}.pdf`}
                        setCount={setCount}
                        setExpandAll={setExpandAll}
                        setlevelCheck={setlevelCheck}
                        count={count}
                        setLoadingDownloadFile={setLoadingDownloadFile}
                        printExcel={handleDownloadSampleFile}
                        printTXT={handleTXT}
                        printpdf={handleGeneratePdf}
                      />
                    </Row>
                  )}

                <div
                  id="printDiv"
                  className="p-4"
                  style={{
                    color: "black",
                    minWidth: "200px",
                    overflowX: "auto",
                    width: "auto",
                  }}
                >
                  <div
                    style={{
                      width: `${
                        dimensionOfPages?.find(
                          (item) => item?.key === paperSizeVal,
                        )?.dimensions[layoutVal === "Portrait" ? 0 : 1]
                      }`,
                      height: "auto",
                      margin: "0 auto",
                      backgroundColor: "white",
                    }}
                    className="border"
                  >
                    <PDFExport
                      paperSize={paperSizeVal || "A4"}
                      margin="1.0cm"
                      scale={scalePDF}
                      landscape={layoutVal === "Landscape"}
                      repeatHeaders={true}
                      fileName={`Trial-Balance-${date}.pdf`}
                      ref={pdfExportComponent}
                    >
                      <div
                        style={{
                          margin: "0.25in",
                        }}
                        ref={contentRef}
                      >
                        {trialBalanceResponse.length > 0 &&
                        periodResponse.length > 0 ? (
                          <>
                            <ReportHeader title="Trial Balance" />

                            <Row>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      From Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                    >
                                      {moment(fromDate).format("DD-MM-YYYY")}
                                    </span>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="5">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      To Date:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                    >
                                      {moment(toDate).format("DD-MM-YYYY")}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md="4" style={{ marginLeft: "70px" }}>
                                <Row>
                                  <Col md="5">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Accounts:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                    >
                                      <b id="test">ALL</b>
                                    </span>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="5">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      Fund Name:
                                    </span>
                                  </Col>
                                  <Col md="6">
                                    <span
                                      id="test"
                                      className="ReportTopStyling"
                                    >
                                      {fund}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            {selectedValues?.columns?.length > 0 ? (
                              <div
                                style={{
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                }}
                              >
                                <table
                                  className="report"
                                  style={{ color: "black" }}
                                  id="table-borderless"
                                >
                                  <thead style={{ alignSelf: "center" }}>
                                    <tr>
                                      {selectedValues?.columns?.includes(
                                        "Code",
                                      ) && (
                                        <th
                                          className="htmltoPdfStyle"
                                          id="test"
                                          style={{ width: "5%" }}
                                        >
                                          Code
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Description",
                                      ) && (
                                        <th
                                          className="htmltoPdfStyle"
                                          id="test"
                                          style={{ width: "30%" }}
                                        >
                                          Description
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Opening Balance",
                                      ) &&
                                        (selectedValues?.balance?.includes(
                                          "Opening Balance Debit",
                                        ) ||
                                          selectedValues?.balance?.includes(
                                            "Opening Balance Credit",
                                          )) && (
                                          <th
                                            id="test"
                                            colSpan={2}
                                            style={{
                                              borderBottom: "0 !important",
                                              background: "#87ceeb",
                                            }}
                                            className="text-center htmltoPdfStyle"
                                          >
                                            Opening Balance
                                          </th>
                                        )}
                                      {selectedValues?.columns?.includes(
                                        "For The Period Balance",
                                      ) &&
                                        (selectedValues?.balance?.includes(
                                          "Period Balance Debit",
                                        ) ||
                                          selectedValues?.balance?.includes(
                                            "Period Balance Credit",
                                          )) && (
                                          <th
                                            id="test"
                                            className="text-center htmltoPdfStyle"
                                            colSpan={2}
                                          >
                                            For The Period Balance
                                          </th>
                                        )}
                                      {selectedValues?.columns?.includes(
                                        "Closing Balance",
                                      ) &&
                                        (selectedValues?.balance?.includes(
                                          "Closing Balance Debit",
                                        ) ||
                                          selectedValues?.balance?.includes(
                                            "Closing Balance Credit",
                                          )) && (
                                          <th
                                            id="test"
                                            className="text-center htmltoPdfStyle"
                                            style={{ background: "#87ceeb" }}
                                            colSpan={2}
                                          >
                                            Closing Balance
                                          </th>
                                        )}
                                    </tr>
                                    <tr>
                                      {selectedValues?.columns?.includes(
                                        "Code",
                                      ) && <th></th>}
                                      {selectedValues?.columns?.includes(
                                        "Description",
                                      ) && <th></th>}
                                      {selectedValues?.balance?.includes(
                                        "Opening Balance Debit",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{ background: "#87ceeb" }}
                                          className="text-right htmltoPdfStyle"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Opening Balance Credit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                        >
                                          Debit
                                        </th>
                                      )}
                                      {selectedValues?.balance?.includes(
                                        "Opening Balance Credit",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{ background: "#87ceeb" }}
                                          className="text-right htmltoPdfStyle"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Opening Balance Debit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                        >
                                          Credit
                                        </th>
                                      )}
                                      {selectedValues?.balance?.includes(
                                        "Period Balance Debit",
                                      ) && (
                                        <th
                                          id="test"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Period Balance Credit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                          className="text-right htmltoPdfStyle"
                                        >
                                          Debit
                                        </th>
                                      )}
                                      {selectedValues?.balance?.includes(
                                        "Period Balance Credit",
                                      ) && (
                                        <th
                                          id="test"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Period Balance Debit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                          className="text-right htmltoPdfStyle"
                                        >
                                          Credit
                                        </th>
                                      )}
                                      {selectedValues?.balance?.includes(
                                        "Closing Balance Debit",
                                      ) && (
                                        <th
                                          style={{ background: "#87ceeb" }}
                                          id="test"
                                          className="text-right htmltoPdfStyle"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Closing Balance Credit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                        >
                                          Debit
                                        </th>
                                      )}
                                      {selectedValues?.balance?.includes(
                                        "Closing Balance Credit",
                                      ) && (
                                        <th
                                          style={{ background: "#87ceeb" }}
                                          className="text-right htmltoPdfStyle"
                                          id="test"
                                          colSpan={
                                            !selectedValues?.balance?.includes(
                                              "Closing Balance Debit",
                                            )
                                              ? 2
                                              : 1
                                          }
                                        >
                                          Credit
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody className="report/-table-body getData">
                                    {trialBalanceResponse
                                      ?.sort(
                                        (a, b) =>
                                          a?.main_family_code -
                                          b?.main_family_code,
                                      )
                                      ?.map((item: any, index: number) => {
                                        let period: any = "";
                                        periodResponse.forEach((periodItem) => {
                                          if (
                                            periodItem.main_family_code ===
                                            item.main_family_code
                                          ) {
                                            period = periodItem;
                                          }
                                        });

                                        return (
                                          <SimpleRows
                                            key={index}
                                            simplerows={item}
                                            period={period}
                                            count={count}
                                            setCount={setCount}
                                            expandall={expandAll}
                                            setExpandAll={setExpandAll}
                                            setlevelCheck={setlevelCheck}
                                            levelCheck={levelCheck}
                                            setMainFamilyCode={
                                              setMainFamilyCode
                                            }
                                            mainFamilyCode={mainFamilyCode}
                                            selectedValues={selectedValues}
                                          />
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <div className="text-center my-5">
                                <b>No column selected</b>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="table-empty">
                            <BsTable className="icon" />
                            <p className="text-center text-primary empty-text">
                              No record found
                            </p>
                          </div>
                        )}
                      </div>
                    </PDFExport>
                  </div>
                </div>

                <div className="row align-items-center">
                  <div className="col-md-4">
                    {selectedValues?.columns?.length > 0 &&
                      trialBalanceResponse.length >= 10 &&
                      periodResponse.length > 0 && (
                        <UncontrolledDropdown
                          className="me-2 mt-2"
                          direction="down"
                        >
                          <DropdownToggle
                            id="TotalRecord_dropdown"
                            style={{
                              background: "none",
                              padding: "0px",
                              margin: "0px",
                            }}
                            className="border"
                          >
                            <div
                              id="report_dropdown"
                              style={{
                                borderRadius: "4px",
                                padding: "5px 15px",
                                color: theme === "light" ? "black" : "white",
                              }}
                            >
                              Per page : {itemsPerPage}
                            </div>
                          </DropdownToggle>
                          <DropdownMenu
                            style={{
                              maxHeight: "300px",
                              overflow: "auto",
                              backgroundColor:
                                theme === "dark" ? "rgb(30, 30, 47)" : "",
                            }}
                          >
                            {[10, 25, 50, "All"].map((pageSize) => (
                              <DropdownItem
                                key={pageSize}
                                className={
                                  itemsPerPage === pageSize
                                    ? "bg-info text-white"
                                    : ""
                                }
                                onClick={() => {
                                  setItemsPerPage(pageSize);
                                  setItemsToShow(
                                    pageSize === "All"
                                      ? trialBalanceResponse?.length
                                      : pageSize,
                                  );
                                }}
                              >
                                {pageSize}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )}
                  </div>
                  <div className="col-md-4">
                    {itemsToShow < trialBalanceResponse?.length &&
                      selectedValues?.columns?.length > 0 && (
                        <div className="d-flex justify-content-center my-2">
                          <button
                            className="btn btn-primary mt-3"
                            onClick={handleShowMore}
                          >
                            Show More
                          </button>
                        </div>
                      )}
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex justify-content-end">
                      {selectedValues?.columns?.length > 0 &&
                        trialBalanceResponse.length > 0 &&
                        periodResponse.length > 0 && (
                          <div
                            id="TotalRecord_dropdown"
                            className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                            style={{
                              borderRadius: "4px",
                              color: theme === "light" ? "black" : "white",
                              marginTop: "13px",
                            }}
                          >
                            Total record :{" "}
                            {selectedValues?.columns?.length > 0
                              ? totalRecordPage
                              : 0}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
};

export default TrialBalanceStatement;
